export default __webpack_public_path__ + "static/media/cover1.b351512b.jpg";